import { TCity, TState, TOfficeInfo } from '@shared-components/types';

const headers = {
	method: 'GET',
	accept: 'text/plain',
};

// fetches offices states
const getAllStates = async () => {
	const apiUrl = `${process.env.CLEARCHOICE_API_URL as string}/States`;
	try {
		const response = await fetch(apiUrl, { headers });
		const data = (await response.json()) as Array<TState>;
		return data;
	} catch (error) {
		if (error instanceof Error) {
			console.warn(`Failed Loading State offices: ${error.message}`);
		}
		return [];
	}
};

// fetches offices cities
const getAllCities = async () => {
	const apiUrl = `${process.env.CLEARCHOICE_API_URL as string}/Cities`;
	try {
		const response = await fetch(apiUrl, { headers });
		const data = (await response.json()) as Array<TCity>;
		return data;
	} catch (error) {
		if (error instanceof Error) {
			console.warn(`Failed Loading All City offices: ${error.message}`);
		}
		return [];
	}
};

// fetches offices by specific state
const getCitiesByState = async (stateCode: string) => {
	const apiUrl = `${process.env.CLEARCHOICE_API_URL as string}/${stateCode}/Cities`;
	try {
		const response = await fetch(apiUrl, { headers });
		const data = (await response.json()) as Array<TCity>;
		return data;
	} catch (error) {
		if (error instanceof Error) {
			console.warn(`Failed Loading City offices in state - ${stateCode}: ${error.message}`);
		}
		return [];
	}
};

// fetches offices by specific state and specific city
const getOfficesByCityState = async (stateCode: string, city: string) => {
	const apiUrl = `${process.env.CLEARCHOICE_API_URL as string}/${stateCode}/${city}`;
	try {
		const response = await fetch(apiUrl, { headers });
		const data = (await response.json()) as Array<TCity>;
		return data;
	} catch (error) {
		if (error instanceof Error) {
			console.warn(`Failed Loading offices in State - ${stateCode} and City - ${city}: ${error.message}`);
		}
		return [];
	}
};

const getOfficeDetailsByCityStateAddress = async (state: string, city: string, line1?: string) => {
	const apiUrl = `${
		process.env.CLEARCHOICE_API_URL as string
	}/CenterLocation/ODPDetails?city=${city}&state=${state}&line1=${line1 || ''}`;
	try {
		const response = await fetch(apiUrl, { headers });
		const data = (await response.json()) as Array<TOfficeInfo>;
		return data;
	} catch (error) {
		if (error instanceof Error) {
			console.warn(
				`Failed Loading office details in State - ${state} and City - ${city}, line1 - ${line1 || ''}: ${
					error.message
				}`
			);
		}
		return [];
	}
};

export { getAllStates, getAllCities, getCitiesByState, getOfficesByCityState, getOfficeDetailsByCityStateAddress };
